<template>
  <div class="form-input-audio">
    <p v-if="visualElementsCount" class="mb-10 text-error">
      Modificando la traccia audio potrebbe essere necessario aggiornare i
      visual elements dalla scheda "Contenuti".
    </p>
    <div class="player mb-4" v-if="value.url && !upload.inProgress">
      <AudioPlayer :src="value.url" />
    </div>
    <button
      type="button"
      class="btn-default mr-2"
      @click="openTrimModal"
      :disabled="disabled"
      v-if="value.url && !upload.inProgress"
    >
      Taglia
    </button>

    <Modal ref="audioTrimModal">
      <div class="p-2">
        <template v-if="trimModalText !== ''">
          {{ trimModalText }}
        </template>
        <FormRow v-else label="Taglia la traccia audio">
          <div v-if="value.url && !upload.inProgress">
            <AudioPlayer
              ref="playerModal"
              v-on:time="setCurrentTimePlayer"
              :src="value.url"
              v-if="trimModalOpen"
            />
            <p v-if="this.trimTimeStart != -1">
              Inizio taglio da: {{ secondsToMMSS(trimTimeStart) }}
            </p>
            <p v-if="this.trimTimeEnd != -1">
              Fine taglio da: {{ secondsToMMSS(trimTimeEnd) }}
            </p>
            <button
              type="button"
              class="btn-default mr-2"
              @click="setTrimStart"
            >
              Imposta Inizio
            </button>
            <button
              type="button"
              class="btn-default mr-2"
              @click="setTrimEnd"
              v-if="this.trimTimeStart != -1"
            >
              Imposta Fine
            </button>
            <button
              type="button"
              class="btn-default mr-2 mt-2"
              v-if="this.trimTimeStart != -1 && this.trimTimeEnd != -1"
              @click="startCut"
            >
              Taglia
            </button>
          </div>
        </FormRow>
      </div>
    </Modal>

    <button
      type="button"
      class="btn-default"
      @click="$refs.fileInput.click()"
      :disabled="disabled"
      v-if="!upload.inProgress"
    >
      {{ value.url ? 'Aggiorna' : 'Scegli' }}
    </button>
    <template v-else>
      <p v-if="upload.preparing">Preparing...</p>
      <p v-if="upload.inProgress">Uploading: {{ upload.progressPercent }}%</p>
    </template>

    <p v-if="upload.error">{{ upload.error.message }}</p>

    <input
      type="file"
      :id="id"
      :name="name"
      class="hidden"
      ref="fileInput"
      @change="handleFile"
      accept=".mp3"
    />
    {{/* accept="audio/x-m4a,audio/*" */}}
  </div>
</template>

<script>
import axios from 'axios'
import gql from 'graphql-tag'

import S3Upload from '@/mixins/S3Upload'
import AudioPlayer from '@/components/AudioPlayer'
import Modal from '@/components/Modal.vue'

const statesCut = {
  NOT_CUTTING: 'NOT_CUTTING',
  SETTING_CUTS: 'SETTING_CUTS',
  SENT_CUTS_AWS: 'SENT_CUTS_AWS',
  GOT_CUTS_AWS: 'GOT_CUTS_AWS',
  RESULT_CUTS_AWS: 'RESULT_CUTS_AWS',
}

export default {
  mixins: [S3Upload],
  components: {
    AudioPlayer,
    Modal,
  },

  props: {
    podcastId: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    value: {
      type: Object,
      default: () => ({
        url: null,
        length: null,
      }),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    visualElementsCount: {
      type: Number,
      default: -1,
    },
  },
  data() {
    return {
      token: this.$store.state.user.profile.token,
      tenant: this.$route.params.tenant,
      trimTimeStart: -1,
      trimTimeEnd: -1,
      trimModalText: '',
      currentTimePlayer: 0,
      stateCut: statesCut.NOT_CUTTING,
      jobStatusInterval: null,
      jobId: -1,
      jobTrack: {},
      trimModalOpen: false,
    }
  },
  watch: {
    stateCut(newCutState) {
      if (newCutState === statesCut.NOT_CUTTING) {
        this.trimTimeStart = -1
        this.trimTimeEnd = -1
        this.trimModalText = ''
        this.jobId = -1
        this.jobTrack = {}
        this.$refs.audioTrimModal.close()
      }
      if (newCutState === statesCut.SETTING_CUTS) {
        this.$refs.audioTrimModal.open()
      }
      if (newCutState === statesCut.SENT_CUTS_AWS) {
        this.trimModalText = 'Stiamo salvando la tua richiesta di taglio audio.'
      }
      if (newCutState === statesCut.GOT_CUTS_AWS) {
        this.trimModalText =
          'Taglio audio iniziato! Non chiudere la finestra o le tue modifiche saranno annullate!'
      }
      if (newCutState === statesCut.RESULT_CUTS_AWS) {
        this.trimModalText =
          'Perfetto e grazie per la pazienza! Abbiamo aggiornato la tua storia!'
        setTimeout(() => {
          this.stateCut = statesCut.NOT_CUTTING
          location.reload()
        }, 3000)
      }
    },
  },
  methods: {
    secondsToMMSS(seconds) {
      const sec = parseInt(seconds)
      const minutes = Math.floor(sec / 60)
      const pad = n => (n < 10 ? `0${n}` : n)
      const remainingSecs = pad(sec % 60)

      return minutes + ':' + remainingSecs
    },
    secondsToHHMMSS(sec) {
      let o = new Date(0)
      let p = new Date(sec * 1000)
      let secondString = new Date(p.getTime() - o.getTime())
        .toISOString()
        .split('T')[1]
        .split('Z')[0]
      return secondString
    },
    setCurrentTimePlayer(newTime) {
      this.currentTimePlayer = newTime
    },
    openTrimModal() {
      this.stateCut = statesCut.SETTING_CUTS
      this.trimModalOpen = true
    },
    closeTrimModal() {
      this.stateCut = statesCut.NOT_CUTTING
      this.trimModalOpen = false
    },
    setTrimStart() {
      if (
        this.currentTimePlayer > this.trimTimeEnd &&
        this.trimTimeEnd !== -1
      ) {
        alert('Puoi tagliare solo prima della fine del taglio')
      } else {
        this.trimTimeStart = this.currentTimePlayer
      }
    },
    setTrimEnd() {
      if (this.currentTimePlayer < this.trimTimeStart) {
        alert("Puoi tagliare solo dopo l'inizio del taglio")
      } else {
        this.trimTimeEnd = this.currentTimePlayer
      }
    },
    async updateAudioRemoteUrl(podcastId, newRemoteUrl) {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation($id: ID!, $track: PartialUpdatePodcastTrackDataInput!) {
              partialUpdatePodcast(id: $id, data: { track: $track }) {
                _id
                track {
                  url
                  length
                }
              }
            }
          `,
          variables: {
            id: podcastId,
            track: newRemoteUrl,
          },
        })
        .then(() => {
          this.stateCut = statesCut.RESULT_CUTS_AWS
        })
    },
    async checkJobStatus() {
      const resultStatus = await axios.get(
        '/.netlify/functions/podcast-audio-trim-status',
        {
          params: {
            tenant: this.tenant,
            podcast: this.podcastId,
            token: this.token,
            jobId: this.jobId,
          },
        },
      )
      const status = resultStatus.data.status
      if (status === 'Complete') {
        this.updateAudioRemoteUrl(this.podcastId, this.jobTrack)
        clearInterval(this.jobStatusInterval)
      }
    },
    async startCut() {
      const differenceTime = this.trimTimeEnd - this.trimTimeStart
      if (differenceTime > 10) {
        const duration = this.secondsToHHMMSS(differenceTime)

        const start_time = this.secondsToHHMMSS(this.trimTimeStart)

        const splitUrl = this.value.url.split('/')
        const audiotrack = splitUrl[splitUrl.length - 1]
        // delete the S3 folder and audiotrack just keep the AWS domain
        splitUrl.splice(-3, 3)
        const domainS3url = splitUrl.join('/') + '/'

        this.stateCut = statesCut.SENT_CUTS_AWS

        const sentTrim = await axios.get(
          '/.netlify/functions/podcast-audio-trim',
          {
            params: {
              tenant: this.tenant,
              podcast: this.podcastId,
              token: this.token,
              audiotrack,
              start_time,
              duration,
            },
          },
        ) // podcast-audio-trim

        const trimmedAudioName = sentTrim.data.message
        if (trimmedAudioName) {
          this.jobId = sentTrim.data.jobId

          this.stateCut = statesCut.GOT_CUTS_AWS

          this.jobTrack = {
            url: domainS3url + trimmedAudioName,
            length: differenceTime,
          }

          this.jobStatusInterval = setInterval(this.checkJobStatus, 3000)
        } // if got reply from amazon
      } // if time track > 10 seconds
      else {
        alert(
          'la traccia audio da tagliare deve essere più lunga di 10 secondi!',
        )
      }
    },
    handleFile(event) {
      const file = event.target.files[0]
      if (!file || !file.type.match(/audio\/(?:.+)/)) {
        this.upload.error = new Error('Invalid file type')
        return
      }

      this.getAudioDuration(file).then(duration => {
        this.uploadFile(file).then(readUrl => {
          this.$emit('input', {
            url: readUrl,
            length: duration,
          })
        })
      })
    },
    getAudioDuration(file) {
      return new Promise(resolve => {
        const audio = document.createElement('audio')
        audio.addEventListener(
          'loadedmetadata',
          () => {
            const duration = audio.duration
            const int_part = Math.trunc(duration)
            const float_part = Number((duration - int_part).toFixed(3))
            if (float_part === 0) {
              resolve(duration + 0.001)
            } else {
              resolve(duration)
            }
          },
          false,
        )
        const reader = new FileReader()

        reader.onload = e => {
          audio.src = e.target.result
        }

        reader.readAsDataURL(file)
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
